import Styled from 'styled-components';

export const Container = Styled.div`
  min-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  background-color: #fff;
`;

export const Paragraph = Styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  img {
    width: 80px;
    margin-bottom: 20px;
  }

  .title {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 8px;
  }

  .text {
    font-size: 14px;
    font-weight: 300;
    line-height: 150%;
  }
`;

export const FooterButton = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
  width: 100%;

  .btn-default-wl,
  .btn-secondary-wl {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 351px;
    padding: 14px 16px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    border: 1px solid transparent;
  }

  .btn-secondary-wl {
    background: #FFFFFF;
    color: #595959;
    border-color: #595959;
  }
`;